export class ElementTypeUniqueIdentifier {
    static stringType = "String";
    static textType = "Text";
    static integerType = "Integer";
    static floatType = "Float";
    static dateTimeType = "DateTime";
    static singleSelectionType = "SingleSelection";
    static documentType = "Document";
}

export class ElementModel {
    id: number;
    type: string;
    data: any;
    value: any;
}

export class ElementStringModel {
    name: string;
    isMandatory: boolean;
}

export class ElementTextModel {
    name: string;
    isMandatory: boolean;
}

export class ElementIntegerModel {
    name: string;
    isMandatory: boolean;
}

export class ElementFloatModel {
    name: string;
    isMandatory: boolean;
}

export class ElementDateTimeModel {
    name: string;
    isMandatory: boolean;
}

export class ElementDefinitionSingleSelectionModel {
    id: number;
    value: string;
}

export class ElementSingleSelectionModel {
    name: string;
    isMandatory: boolean;
    definition: ElementDefinitionSingleSelectionModel[];
}

export class ElementDocumentModel {
    definition: ElementDefinitionDocumentModel = new ElementDefinitionDocumentModel();
    name: string;
    isMandatory: boolean;
}

export class ElementDefinitionDocumentModel {
    description: string;
    isDocumentMandatory: boolean;
}

export class ElementValueModel {
    id: number;
    value: any;
}
